import { render } from "./InpostGeoWidget.vue?vue&type=template&id=cfba3490&scoped=true"
import script from "./InpostGeoWidget.vue?vue&type=script&lang=js"
export * from "./InpostGeoWidget.vue?vue&type=script&lang=js"

import "./InpostGeoWidget.vue?vue&type=style&index=0&id=cfba3490&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfba3490"]])

export default __exports__